// extracted by mini-css-extract-plugin
export default {"rebateAmount":"aHowIzQIt8c1eWI4JoSY"};